import mobile_routes from './routes.mobile.js'

function loadView(view) {
  return () => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}

let routes = [
  {
    path: '/',
    redirect: '/app/'
  },
  {
    path: '/app/',
    redirect(to) {
      if (HM.is_mobile) { return '/app/mobile/transactions/calendar'; } else { return '/app/my/transactions/calendar'; }
    }
  },
  {
    path: '/app/logout',
    name: 'logout_page',
    meta: { require_auth: false },
    component: loadView('guest/logout')
  },
  {
    path: '/app',
    name: 'guest_pages',
    meta: { require_auth: false },
    component: loadView('guest'),
    children: [
      {
        path: 'login',
        name: 'login_page',
        meta: { require_auth: false },
        component: loadView('guest/login')
      },
      {
        path: 'sign_up',
        name: 'sign_up_page',
        meta: { require_auth: false },
        component: loadView('guest/sign_up')
      },
      {
        path: 'changelog',
        name: 'changelog_page',
        meta: { require_auth: false },
        component: loadView('guest/changelog')
      }
    ]
  },
  {
    path: '/app/my',
    component: loadView('inside/inside'),
    children: [
      // {
      //   path: 'dashboard'
      //   component: loadView('inside/pages/dashboard')
      // }
      {
        path: 'accounts',
        name: 'accounts_page',
        component: loadView('inside/pages/accounts')
      },
      {
        path: 'import',
        name: 'import_page',
        component: loadView('inside/pages/import')
      },
      {
        path: 'settings',
        name: 'settings_page',
        component: loadView('inside/pages/settings'),
        children: [
          {
            path: 'general',
            name: 'general_settings_page',
            component: loadView('inside/pages/settings/general')
          },
          {
            path: 'payment',
            name: 'payment_page',
            component: loadView('inside/pages/settings/payment')
          },
          {
            path: 'subscription',
            name: 'subscription_page',
            component: loadView('inside/pages/settings/subscription')
          },
          {
            path: 'danger_zone',
            name: 'danger_zone_page',
            component: loadView('inside/pages/settings/danger_zone')
          }
        ]
      },
      {
        path: 'reports',
        name: 'reports_page',
        component: loadView('inside/pages/reports'),
        children: [
          {
            path: 'compare_periods',
            name: 'compare_periods', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/reports/compare_periods')
          },
          {
            path: 'net_worth',
            name: 'net_worth_page',
            component: loadView('inside/pages/reports/net_worth')
          }
        ]
      },
      {
        path: 'transactions',
        name: 'transactions_page',
        component: loadView('inside/pages/transactions'),
        props: true,
        children: [
          {
            path: 'calendar',
            name: 'calendar', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/calendar'),
            props: true
          },
          {
            path: 'list',
            name: 'list', // don't rename those, some logic is linked to those names
            component: loadView('inside/pages/list'),
            props: true
          }
        ]
      },
      {
        path: 'friends',
        name: 'friends_page',
        component: loadView('inside/pages/friends')
      },
    ]
  }
];

routes = routes.concat(mobile_routes)
routes.push(
  { path: '*', component: loadView('404') }
);

const router = new VueRouter({
  linkActiveClass: 'is-active',
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if ((to.name === 'calendar') && (from.name === 'calendar')) { return false; }
      return { x: 0, y: 0 };
    }
  },

  routes
});

// router.beforeEach (to, from, next) ->
//   if !to.name && (to.path.includes('/ru') || to.path.includes('/en') || to.path == '/')
//     window.location = HM.promo_site_url + to.path
//   else
//     next()
// router.afterEach (to, from) -> HM.intercom('update')

export default router
